import { queryClient } from '@/lib/react-query';
import {
  CreateDTO,
  useCreateMutationFactory,
  UseCreateMutationProps,
} from '@/lib/react-query/create';
import { WorkOrder } from '@/types';
import { create } from '@/utils/api';
import { featureKeys, featurePath, WorkOrderSearchParams } from '.';

export type CreateWorkOrderDTO = CreateDTO<WorkOrder, WorkOrderSearchParams>;

const createWorkOrder = ({ data, params = {} }: CreateWorkOrderDTO) =>
  create<WorkOrder>(`${featurePath}`, data, params);

export const useCreateWorkOrder = (options?: UseCreateMutationProps<WorkOrder>) => {
  return useCreateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: createWorkOrder,
    onSuccess: (data) => {
      if (data?.taskable_type && data?.taskable_id) {
        queryClient.invalidateQueries({
          queryKey: [{ scope: data.taskable_type, entity: 'detail', id: data.taskable_id }],
        });
      }
    },
    ...options,
  });
};
